import { SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Types/utilTypes'
import {
	ChatChannelHandler,
	ChatFileState,
	chatSlice,
	ChatSocketDataPayload,
	chatSocketSlice,
	isMessageModel,
	isServiceMessageModel,
	MessageType,
} from 'Pages/chat'
import { store } from 'Store'

export class ChatChannel implements ChatChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: ChatSocketDataPayload) {
		const chat_id = store.getState().chat.chat?.currentChat?.id
		const token = store.getState().chat.chat?.chatToken
		const authData = store.getState().auth

		const { message } = data
		const identifier = data?.identifier
		if (identifier?.chat_id === chat_id) {
			if (data?.type === SocketMessageTypes.CONFIRM_SUBSCRIPTION) {
				this.dispatch(chatSocketSlice.actions.setSubscription(true))
			} else if (isServiceMessageModel(message)) {
				const { unreaded, state, ticket_score_id } = message

				this.dispatch(chatSlice.actions.setUnreaded(false))

				if (unreaded) {
					this.dispatch(chatSlice.actions.setUnreaded(true))
				}
				if (state === 'initial') {
					this.dispatch(chatSlice.actions.setServiceMessage(true))
					this.dispatch(chatSlice.actions.setViewRating(false))
				}
				if (ticket_score_id) {
					this.dispatch(chatSlice.actions.setTicketScoreId(ticket_score_id))
					this.dispatch(chatSlice.actions.setViewRating(true))
				}
			} else if (isMessageModel(message) && message?.id) {
				this.dispatch(chatSlice.actions.setSocketMessage(message))

				if (
					message?.meta_info?.neo_user_id !== authData.id &&
					message?.message_type !== MessageType.NOTIFY
				) {
					this.dispatch(chatSlice.actions.setUnreaded(true))
				}

				if (message?.message_type === MessageType.MESSAGE && message?.meta_info.chat_file_id) {
					this.dispatch(chatSlice.actions.deleteFileInProgress(message?.meta_info.chat_file_id))
					this.dispatch(chatSlice.actions.setUnreaded(false))
				}
				if (message?.message_type === MessageType.NOTIFY) {
					this.dispatch(chatSlice.actions.setServiceMessage(false))
				}
				if (message?.state === ChatFileState.SUCCESS && message?.chat_file_id)
					this.dispatch(
						chatSlice.actions.downloadFile({
							token,
							file_id: message.chat_file_id,
							file_name: '',
						})
					)
			}
		}
	}
}
